import { render, staticRenderFns } from "./listaPropuestas.vue?vue&type=template&id=0a13da8c"
import script from "./listaPropuestas.vue?vue&type=script&lang=js"
export * from "./listaPropuestas.vue?vue&type=script&lang=js"
import style0 from "./listaPropuestas.vue?vue&type=style&index=0&id=0a13da8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports